import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import FilterCollection from 'components/organisms/FilterCollection';

const TimeFilter = (props) => {
  const { t } = useTranslation();
  const { params, getParam } = props;
  const [TimeList, setTimeList] = useState([]);

  useEffect(() => {
    let newRankList = [...TimeList];
    for (let i = 0; i < 24; i++) {
      newRankList.push({
        label: i + t('시'),
        value: i < 10 ? '0' + i : String(i),
      });
    }
    setTimeList(newRankList);
    // eslint-disable-next-line
  }, []);

  return (
    <FilterCollection
      label={t('시간선택')}
      name="statsHh"
      params={params}
      value={params.statsHh}
      type="checkbox"
      list={TimeList}
      callBack={getParam}
      labelKey="label"
      valueKey="value"
      popoverMaxWidth={650}
      popoverHeight={470}
    />
  );
};

export default TimeFilter;
